import { Subscribable } from "knockout";
import { withEffects } from "mixins/withEffects";

export default abstract class WCCAnimator<C> {
    protected effects = withEffects();

    private isAnimationRequired = ko.observable(false);
    private isAnimating = ko.observable(false);

    private animationDuration: Subscribable<number>
    private animationStartTime = ko.observable<number>();
    private isFastAnimationMode = ko.observable(false);
    private animationContext = ko.observable<C>();

    private canAnimate: Subscribable<boolean>

    constructor() {
        this.animationDuration = ko.pureComputed(() => this.getAnimationDuration());

        this.canAnimate = ko.pureComputed(() => this.checkIfAllowedToAnimate());

        const allowToAnimateNextFrame = ko.pureComputed(() => this.isAnimationRequired() && !this.isAnimating());

        queueMicrotask(() => {
            this.effects.register(allowToAnimateNextFrame => {
                if (allowToAnimateNextFrame) {
                    this.isAnimating(true);
                    this.isAnimationRequired(false);

                    this.animate(!this.canAnimate());
                }
            }, [allowToAnimateNextFrame]);            
        });
    }

    update() {
        this.isAnimationRequired(true);
    }

    dispose() {
        this.effects.dispose();
    }

    protected abstract getAnimationDuration(): number
    protected abstract getAnimationContext(): C

    protected checkIfAllowedToAnimate() {
        return this.animationDuration() > 0 && !this.effects.isDisposed();
    }    

    protected onProgress(progress: number, context: C) { }
    protected beforeAnimation(context: C) { }
    protected afterAnimation(context: C) { }

    private animate(fast = false) {
        this.animationStartTime(undefined);
        this.isFastAnimationMode(fast);
        this.animationContext(this.getAnimationContext());

        requestAnimationFrame(now => this.animateNextFrame(now));
    }

    private animateNextFrame(now: number) {
        const context = <C>this.animationContext();

        if (this.animationStartTime() == undefined)
            this.animationStartTime(now);

        const start = <number>this.animationStartTime();
        const change = now - start;

        let progress = change / this.animationDuration() * 100;

        if (progress > 0 && this.isFastAnimationMode())
            progress = 100;

        if (progress > 100)
            progress = 100;

        if (progress === 0)
            this.beforeAnimation(context);

        this.onProgress(progress, context);

        if (progress < 100 && (progress === 0 || this.canAnimate())) {
            requestAnimationFrame(now => this.animateNextFrame(now));
        } else {
            this.afterAnimation(context);
            this.isAnimating(false);
        }
    }
}